import * as types from '../actionTypes/app'

export function setLoading(isLoading) {
  return {
    type: types.SET_LOADING_STATUS,
    isLoading: isLoading
  }
}

export function incrementErrorCount() {
  return {
    type: types.INCREMENT_ERROR_COUNT
  }
}

export function clearErrorCount() {
  return {
    type: types.CLEAR_ERROR_COUNT
  }
}

export function setAjaxResponse(ajaxResponse) {
  return {
    type: types.SET_AJAX_RESPONSE,
    ajaxResponse: ajaxResponse
  }
}

export function clearAjaxResponse() {
  return {
    type: types.CLEAR_AJAX_RESPONSE
  }
}

export function toggleMenu() {
  return {
    type: types.TOGGLE_MENU
  }
}


// WEBPACK FOOTER //
// ./src/actions/app.js